import { Component, ContentChildren, Input, QueryList, TemplateRef, AfterContentInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { NxTemplateDirective } from '../../directives/nx-template.directive';



@Component({
  // tslint:disable-next-line:component-selector
  selector: "div[pageTitle-box], nx-pageTitle-box",
  templateUrl: "pageTitle-box.html",
  host: {
    'class': 'flex flex-col ml-1'
  },
  styleUrls: ["./pageTitle-box.scss"]
})
export class PageTitleBoxComponent implements AfterContentInit {

  /**
   * indicates, if the context menu of the action button is visible
   */
  public menuVisible = false;

  /**
   * The default class of the label element
   */
  public labelDefaultClass = 'text-lg font-medium leading-4 mt-[0.375rem]';

  /**
   * Overwrites the default class of the label element
   */
  @Input() labelOverwriteClass: string | undefined;

  /**
   * Classes that sould be added to the default class of the label element
   */
  @Input() labelAdditionalClass: string | undefined;

  /**
   * The label of the box
   */
  @Input() label: string;

  /**
   * The subLabel of the box
   */
  @Input() bcRootLvlLabel: string | undefined;

  /**
   * Path the router should be navigated to when the sublabel is cliecked
   */
  @Input() bcRootLvlPath: string | undefined;

  /**
   * The subLabel of the box
   */
  @Input() bcRootLvl1Label: string | undefined;

  /**
   * Path the router should be navigated to when the sublabel is cliecked
   */
  @Input() bcRootLvl1Path: string | undefined;

  /**
   * icon of the box that should be shown on the start position
   */
  @Input() icon: string | undefined;

  /**
   * the tooltip for the icon
   */
  @Input() iconToolTip: string | undefined;

  /**
   * Menu items for the context menu. Currently this is the "MenuItem" from PrimeNG,
   * but this will probably change if we start to implement the context menues with our
   * own command pattern. For testing purposes, this works.
   */
  @Input() menuItems: MenuItem[] | undefined;

  /**
   * All templates that are inside the box tag in the parent component
   */
  @ContentChildren(NxTemplateDirective) templates!: QueryList<NxTemplateDirective>;

  /**
   * The template for the start of the box
   */
  public startTemplate: TemplateRef<any> | undefined;

  /**
   * The template for the end of the box
   */
  public endTemplate: TemplateRef<any> | undefined;

  /**
   * The template for the label of the box
   */
  public labelTemplate: TemplateRef<any> | undefined;

  /**
   * The template for the label of the box
   */
  public subLabelTemplate: TemplateRef<any> | undefined;

  /**
   * The template for displaying a status tag <p-tag>
   */
  public tagTemplate: TemplateRef<any> | undefined;

  constructor(
    private router: Router
  ) {
  }

  /**
   * Walks through all templates and assigns them to the corresponding variables
   */
  ngAfterContentInit() {
    this.templates.forEach((item) => {
        switch (item.getType()) {
            case 'start':
                this.startTemplate = item.template;
                break;
            case 'label':
                this.labelTemplate = item.template;
                break;
            case 'tag':
                this.tagTemplate = item.template;
                break;
            case 'end':
              this.endTemplate = item.template;
              break;
        }
    });
  }

  /**
   * Method return the class attribute for the label element
   *
   * @returns string - the class of the label element
   */
  getLabelClass(): string {
    // if we have an overwrite, no merging, just return the overwrite
    if(this.labelOverwriteClass){
      return this.labelOverwriteClass;
    }
    let labelClass = this.labelDefaultClass;
    if(this.labelAdditionalClass){
      labelClass += ' ' + this.labelAdditionalClass;
    }
    return labelClass;
  }

  /**
   * Checks, if a button for a context menu should be shown
   * @returns - true, if the button should be shown, false otherwise
   */
  shouldShowButton(): boolean {
    if(this.endTemplate === undefined && this.menuItems !== undefined && this.menuItems.length > 0){
      return true;
    }
    return false;
  }

  /**
   * triggers, when the context menu will be showm and sets the menuVisible flag to true
   */
  public onMenuShow() {
    this.menuVisible = true;
  }

  /**
   * triggers, when the context menu will be hidden and sets the menuVisible flag to false
   */
  public onMenuHide() {
    this.menuVisible = false;
  }

  public goTo(path: string) {
    this.router.navigate([path]);
  }

}
